import React, { ReactElement } from 'react';
import styles from './emptyChartState.module.scss';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import Selectors from 'src/utils/selectors';
import LiteralsService from 'src/services/literals/LiteralsService';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

interface Props {
    text?: string;
    subtext?: string;
    icon?: ReactElement;
}

const EmptyChartState = ({ text, subtext, icon }: Props): JSX.Element =>
    icon ? (
        <div
            className={`${styles.emptyChartWithSubtext} ${styles.emptyChartBase}`}
            data-cy={Selectors.SpendSmart.EMPTY_CHART}
        >
            <div className="dls-bright-blue">{icon}</div>
            <Typography variant={TypographyVariants.BODY_BOLD} className={`${DlsTypographyVariants.BODY_3} after10`}>
                {text}
            </Typography>
            {subtext && (
                <Typography
                    variant={TypographyVariants.BODY}
                    className={`${DlsTypographyVariants.BODY_1} ${styles.subtext}`}
                >
                    {subtext}
                </Typography>
            )}
        </div>
    ) : (
        <div
            className={`${styles.emptyChartBase} ${styles.emptyChartDefault}`}
            data-cy={Selectors.SpendSmart.EMPTY_CHART}
        >
            <Typography variant={TypographyVariants.BODY} className={DlsTypographyVariants.BODY_1}>
                {text || LiteralsService.getLiteral('General.graph.noData')}
            </Typography>
        </div>
    );

export default EmptyChartState;
